export const isValidArweaveAddress = (address: string) => /^[a-zA-Z0-9_-]{43}$/.test(address);
